export default "__VITE_ASSET__EobIxLhX__"